// reduced/modified version of https://github.com/hkk12369/pico-emitter/blob/main/index.js

type EventCallback = (...args: unknown[]) => void

class PicoEmitter {
  private eventTarget: EventTarget
  private callbackMap: Map<EventCallback, EventListener>

  constructor () {
    try {
      this.eventTarget = new EventTarget()
    } catch {
      // EventTarget not supported, use DOM as EventTarget
      this.eventTarget = document.createDocumentFragment()
    }
    this.callbackMap = new Map()
  }

  $on (name: string, callback: EventCallback, options?: AddEventListenerOptions | boolean): void {
    // eslint-disable-next-line prefer-spread
    const pCallback = ((e: Event) => callback.apply(null, (e as Event & { _p: unknown[] })._p)) as EventListener
    this.eventTarget.addEventListener(name, pCallback, options)
    this.callbackMap.set(callback, pCallback)
  }

  $off (name: string, callback: EventCallback): void {
    const pCallback = this.callbackMap.get(callback)
    if (pCallback) {
      this.eventTarget.removeEventListener(name, pCallback)
      this.callbackMap.delete(callback)
    }
  }

  $emit (name: string, ...args: unknown[]): void {
    const e: Event & { _p?: unknown[] } = new Event(name)
    e._p = args
    this.eventTarget.dispatchEvent(e)
  }
}

const emitter = new PicoEmitter()

export default emitter
